import React from 'react';
import { Button } from 'react-bootstrap';
import ClipLoader from 'react-spinners/ClipLoader';

const ButtonRequest = ({ title = '', titleLoading = '', handlerFn = () => {}, isButtonDisabled = false, isLoading = false, color = 'primary' }) => {
  // if (isButtonDisabled) {
  //   console.log('disablet buton request');
  // }
  return (
    <Button variant={color} size="lg" onClick={() => handlerFn()} style={{ height: '36px' }} disabled={isButtonDisabled}>
      {isLoading && <ClipLoader color="#FFFFFF" loading={isLoading} size={10} />}
      {isLoading ? titleLoading : title}
    </Button>
  );
};
export default ButtonRequest;
